import type { SceneObject } from "../../modeling/types.ts";

let _nextToken = 0;
const _tokens = new WeakMap<object, number>();

function tokenForRef(ref: object): number {
  let token = _tokens.get(ref);
  if (token === undefined) {
    token = ++_nextToken;
    _tokens.set(ref, token);
  }
  return token;
}

export function refCacheKey(prefix: string, ref: object): string {
  return `${prefix}:${tokenForRef(ref)}`;
}

export function sceneObjectCacheKey(obj: SceneObject): string {
  return `scene:${obj.id}:${tokenForRef(obj)}`;
}

function optionalRefToken(ref: object | null | undefined): number {
  return ref ? tokenForRef(ref) : 0;
}

export function sceneObjectGeometryCacheKey(obj: SceneObject): string {
  return [
    "scene-geometry",
    obj.id,
    tokenForRef(obj.vertices),
    tokenForRef(obj.indices),
    tokenForRef(obj.topology),
    optionalRefToken(obj.uvs),
    optionalRefToken(obj.skinRadii),
    optionalRefToken(obj.vertexGroups),
    optionalRefToken(obj.materialSlots),
    optionalRefToken(obj.faceAttributes),
    optionalRefToken(obj.faceAttributes?.materialIndex),
  ].join(":");
}
